import React from 'react'
import { TopBar } from 'prove-common'
import { AppLogo } from '../app-logo/AppLogo'

export const SelectThemeScreenTopBar: React.FC = () => {
  return (
    <TopBar
      logo={<AppLogo />}
      breadcrumbItems={[
        {
          label: 'Innstillinger',
          to: '/settings'
        },
        {
          label: 'Tema'
        }
      ]}
    />
  )
}
